import styles from './Tooltip.module.css';

/**
 * Composant Tooltip générique et réutilisable
 * @param {object} props
 * @param {boolean} props.isOpen - Si le tooltip est ouvert
 * @param {number} props.x - Position X
 * @param {number} props.y - Position Y
 * @param {React.ReactNode} props.children - Contenu du tooltip
 * @param {string} [props.className] - Classes CSS additionnelles
 * @param {number} [props.offsetX=10] - Décalage horizontal
 * @param {number} [props.offsetY=10] - Décalage vertical
 * @returns {JSX.Element | null}
 */
function Tooltip({
  isOpen,
  x,
  y,
  children,
  className = '',
  offsetX = 10,
  offsetY = 10,
}) {
  if (!isOpen) return null;

  return (
    <div
      id="calendar-tooltip"
      className={`${styles.tooltip} ${className}`}
      style={{
        left: x + offsetX,
        top: y + offsetY,
      }}
    >
      {children}
    </div>
  );
}

export default Tooltip;
